module.exports = __webpack_public_path__ + "static/img/track.a504161.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/track.svg
// module id = +WT2
// module chunks = 1